var React = require('react');

function BuildingType (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M6.25 6.25H14.75V14.75H6.25V6.25ZM7.75 7.75V13.25H13.25V7.75H7.75ZM17.25 6.25H25.75V14.75H17.25V6.25ZM18.75 7.75V13.25H24.25V7.75H18.75ZM6.25 17.25H14.75V25.75H6.25V17.25ZM7.75 18.75V24.25H13.25V18.75H7.75ZM17.25 17.25H25.75V25.75H17.25V17.25ZM18.75 18.75V24.25H24.25V18.75H18.75Z","fill":"#2E2B26"}));
}

BuildingType.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = BuildingType;

BuildingType.default = BuildingType;
